<template>
    <div class="about-header">
        <app-header v-if="this.$route.params.page === 'about-us'" :cover="coverAboutUs" :texts="texts"></app-header>
        <app-header v-if="this.$route.params.page === 'mission-and-values'" :cover="coverMissionAndValues" :texts="texts"></app-header>
        <app-header v-if="this.$route.params.page === 'key-figures'" :cover="coverKeyFigures" :texts="texts"></app-header>
        <app-header v-if="this.$route.params.page === 'r-and-d'" :cover="coverRAD" :texts="texts"></app-header>
        <app-header v-if="this.$route.params.page === 'rolling-plant'" :cover="coverRollingPlant" :texts="texts"></app-header>
        <app-header v-if="this.$route.params.page === 'extrusion-plant'" :cover="coverExtrusionPlant" :texts="texts"></app-header>
        <app-header v-if="this.$route.params.page === 'timeline'" :cover="coverTimeline" :texts="texts"></app-header>
    </div>
</template>

<script>
import Header from "../shared/Header";
export default {
  components: {
    appHeader: Header
  },
  data() {
    return {
      coverAboutUs: ["/static/img/about/au/header.jpg", "image"],
      coverMissionAndValues: ["/static/img/about/mav/header.jpg", "image"],
      coverKeyFigures: ["/static/img/about/kf/header.jpg", "image"],
      coverRAD: ["/static/img/about/rad/header.jpg", "image"],
      coverRollingPlant: ["/static/img/about/rp/header.jpg", "image"],
      coverExtrusionPlant: ["/static/img/about/ep/header.jpg", "image"],
      coverTimeline: ["/static/img/about/timeline/header.jpg", "image"],
      texts: ["За компанията"]
    };
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/about/Header.vue